module.exports = __webpack_public_path__ + "static/media/Malaysia.8bb72e56.jfif";